class NewCampusModalService {

    constructor(
        $http,
        appConfig
    ) {
        'ngInject';

        this.$http = $http;
        this.appConfig = appConfig;
    }

    /***
     * Create a new campus.
     *
     * @param clientId      the ID of the parent client for this campus.
     * @param campusName    the name of the campus.
     * @param countryId     the ID of the country for the new campus.
     *
     * @returns {Promise}
     */
    createCampus(clientId, campusName, countryId) {
        const data = {
            name: campusName,
            country: countryId,
            services: []
        };
        return this.$http.post(`${this.appConfig.apiUrl}/clients/${clientId}/campuses/`, data);
    }

}

export default NewCampusModalService;


// WEBPACK FOOTER //
// ./app/components/client-edit/new-campus-modal/new-campus-modal-service.js